import Vue from 'vue'
import axios from 'axios';
import Router from 'vue-router';
import VueLocalStorage from 'vue-ls';
import config from '@/util/configuracao.js'

Vue.use(VueLocalStorage);

export function login() {
    window.location.href = config.URL_PORTAL + 'rest/oauth2/authorize?response_type=code&client_id=' + config.clientID;
}

export function logout() {

    if(getAccessToken() != 'undefined' || getAccessToken() != null){
        clearAccessToken();
    }

    if(getCurrentProject() != 'undefined' || getCurrentProject() != null){
        clearCurrentProject();
    }

    if(getProjects() != 'undefined' || getProjects() != null){
        clearProjects();
    }

    if(getUserFull() != 'undefined' || getUserFull() != null){
        clearUser();
    }

    window.location.assign(config.URL_PORTAL + 'rest/auth/logout')
}

export function requireAuth(to, from, next) {
    if (isLoggedIn() == null) {
        getAuthorization();
    } else {
        if(getUser() == null)
           retornUserInfo(getAccessToken());
        next();
    }
}

export function getAuthorization() {
    window.location.assign(config.URL_PORTAL + 'rest/oauth2/authorize?response_type=code&client_id=' + config.clientID)
}

export function getUser() {
    return Vue.ls.get('USER');
}

export function getUserFull() {
    return Vue.ls.get('USER_FULL');
}

export function getAccessToken() {
    return Vue.ls.get('ACCESS_TOKEN');
}

export function getCurrentProject() {
    return Vue.ls.get('CURRENT_PROJECT');
}

export function getProjects() {
    return Vue.ls.get('PROJECTS');
}

function clearAccessToken() {
    Vue.ls.remove('ACCESS_TOKEN');
}

function clearCurrentProject() {
    Vue.ls.remove('CURRENT_PROJECT');
}

function clearUser() {
    Vue.ls.remove('USER');
    Vue.ls.remove('USER_FULL');
}

function clearProjects() {
    Vue.ls.remove('PROJECTS');
}

export function setAccessToken(code) {
    let accessToken = '';

    var qs = require('qs');

    axios({
        method: 'post',
        url: config.URL_PORTAL + 'rest/oauth2/request_token',
        data: qs.stringify({
            grant_type: 'authorization_code',
            client_id: config.clientID,
            client_secret: config.secretKey,
            code: code,
            redirect_uri: 'none'
        }),
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
        .then(function (response) {
            accessToken = response.data.access_token;
            Vue.ls.set('ACCESS_TOKEN', accessToken);
            retornUserInfo(accessToken);
        })
       .catch(function (error) {
           console.log(error);
       });
}

export function setCurrentProject(projeto) {
    return Vue.ls.set('CURRENT_PROJECT', projeto);
}

export function isLoggedIn() {
    return Vue.ls.get('ACCESS_TOKEN')
}

export function carregarHeader(){
    EffectivePortalHeader.includeHeader('header',  getUserFull(), config.clientID, getProjects()[0].id, getAccessToken(), '');
}

function retornUserInfo(access_token){
    axios({
        method: 'get',
        url: config.URL_PORTAL + 'rest/api/userInfo',
        params:{
            access_token: access_token
        }
    })
    .then(function (response) {
        if(response.data.status == 'ERROR')
            getAuthorization();
        else{
            Vue.ls.set('USER_FULL',  response.data);
            Vue.ls.set('USER',  response.data.result.user);
            Vue.ls.set('PROJECTS',  response.data.result.projects);

            var cookie = Vue.cookie.get('acesso') + 1;

            Vue.cookie.set('acesso', cookie, { expires: '1Y' });

            setCurrentProject(getProjects()[0].id)

            EffectivePortalHeader.includeHeader('header', response.data, config.clientID, getProjects()[0].id, access_token, '');

        }
    })
    .catch(function (error) {
        console.log(error);
    });
}


// WEBPACK FOOTER //
// ./src/auth/auth.js